import React, { useEffect, useState } from 'react';
import './Loader.scss';
import { t } from 'i18next';

interface LoaderProps {
  loadingLabel?: string;
}

const Loader: React.FC<LoaderProps> = ({ loadingLabel = null }) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoader(true);
    }, 300);

    return () => clearTimeout(timeout);
  }, []);

  if (!showLoader) return null;

  const hasText = loadingLabel !== null;

  return (
    <div className="loader">
      <div className="loader__overflow" />
      <div className={`loader__container ${hasText && 'loader__container--text'}`}>
        <div className="loader__spinner" />
        {hasText && <div className="loader__text">{t(loadingLabel)}</div>}
      </div>
    </div>
  );
};

export default Loader;
